<template lang="pug">
.renewal-container(v-if="show")
  .close-btn(@click="close")
    img(
      src="https://m.hellobike.com/resource/helloyun/08345/nEFYzuxKIh.png?x-oss-process=image/quality,q_80"
    )
  .renewal-block
    .life-card-top
    .life-card-under
      .life-card-under-top
        .life-card-img
          img(v-if="newCustomer"
            src="https://m.hellobike.com/resource/helloyun/08345/3NycOoj4S2.png"
          )
          img(v-else
            src='https://m.hellobike.com/resource/helloyun/08345/6be_1umVqq.png'
          )
        .life-card-word {{groupList[0].title}}
      .life-card-top-list
        .life-card-item(v-for="(item, index) in firstList")
          .life-block-info
            .big-word-font {{item.cardMoney}}
            .small-word-font {{item.cardSign}}
          .life-block-middle-info {{item.couponWord}}
          .life-block-bottom-info {{item.goodsPropDesc}}
        .business-list
      .life-card-second
        .life-card-img
          img(
            src="https://m.hellobike.com/resource/helloyun/08345/6Big75fJnO.png"
          )
        .life-card-word {{groupList[1].title}}
      .life-card-second-bussiness
        .life-card-second-bussiness-item(v-for="(item, index) in ladderPropGroupList")
          lifeCardBussiness(:ladderDetailMap="ladderDetailMap" :info="item")
  .shadow(@click="close")
</template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getNoScroll } from '@/utils';
import { getSource } from '../../../../utils';
import lifeCardBussiness from './life-card-bussiness.vue';

export default {
  components: {
    lifeCardBussiness,
  },
  props: {
    groupList: {
      type: Array,
      required: true,
    },
    ladderPropGroupList: {
      type: Array,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
    newCustomer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      show: false,
      lifeList: [],
      bussinessList: [],
    };
  },
  computed: {
    openPrice() {
      if (this.allMonth) {
        return this.signInfoDTO.firstSignPrice;
      }
      return this.price || '-';
    },
    firstList() {
      if (this.groupList && Array.isArray(this.groupList) && this.groupList.length > 0 && this.groupList[0].coupons) {
        return this.groupList[0].coupons.slice(0, 4);
      }
      return [];
    },
  },
  destroyed() {
    this.timer = null;
    this.timeout = null;
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_button',
      contentId: 'platform_opencard_button',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.$emit('update:show', false);
      this.show = false;
      getNoScroll(false);
    },
  },
};
</script>
<style lang="less" scoped>
.renewal-container {
  font-family: PingFangSC-Medium, PingFang SC, sans-serif;

  .close-btn {
    position: fixed;
    right: 0.1rem;
    bottom: 5.9rem;
    z-index: 222;
    opacity: 0.57;

    img {
      width: 0.26rem;
      height: 0.26rem;
    }
  }

  .renewal-block {
    position: fixed;
    bottom: 0;
    z-index: 222;
    height: 5.8rem;
    width: 100%;
    background: #fff;
    border-radius: 0.1rem 0.1rem 0 0;

    .life-card-top {
      width: 100%;
      height: 0.62rem;
      background-image: url(https://m.hellobike.com/resource/helloyun/08345/e7BjEBwMOe.png);
      background-size: 100% 100%;
      padding: 0.63rem 0 0 0.12rem;
    }

    .life-card-under {
      height: 90%;
      overflow-y: auto;

      .life-card-under-top {
        display: flex;
        justify-content: flex-start;
        padding: 0 0 0 0.12rem;

        .life-card-img {
          img {
            width: 0.62rem;
            height: 0.2rem;
          }
        }

        .life-card-word {
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #242729;
          line-height: 0.2rem;
          margin-left: 0.06rem;
        }
      }

      .life-card-top-list {
        margin-top: 0.07rem;
        padding: 0 0.12rem;
        display: flex;
        justify-content: space-between;

        .life-card-item {
          width: 0.82rem;
          height: 0.84rem;
          background-image: url(https://m.hellobike.com/resource/helloyun/08345/H29Zeleja_.png);
          background-size: 100% 100%;

          .life-block-info {
            text-align: center;
            display: flex;
            justify-content: center;

            .big-word-font {
              margin-top: 0.03rem;
              font-size: 0.26rem;
              font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              font-weight: bold;
              color: #f54311;
              line-height: 0.3rem;
            }

            .small-word-font {
              margin-top: 0.12rem;
              font-size: 0.11rem;
              font-family: PingFangSC-Regular, PingFang SC, sans-serif;
              font-weight: 400;
              color: #f54311;
              margin-left: 0.01rem;
            }
          }

          .life-block-middle-info {
            text-align: center;
            font-size: 0.11rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #b16652;
            line-height: 0.16rem;
          }

          .life-block-bottom-info {
            text-align: center;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #fef8ea;
            line-height: 20px;
            margin-top: 0.1rem;
          }
        }
      }

      .life-card-second {
        margin-top: 0.2rem;
        display: flex;
        padding-left: 0.12rem;

        .life-card-img {
          img {
            width: 0.62rem;
            height: 0.2rem;
          }
        }

        .life-card-word {
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #242729;
          line-height: 0.2rem;
          margin-left: 0.06rem;
        }
      }

      .life-card-second-bussiness {
        margin-top: 0.07rem;
        overflow: scroll;
        padding: 0 0.1rem;

        .life-card-second-bussiness-item {
          margin-bottom: 0.15rem;
        }
      }
    }

    .close-bottom {
      padding: 0 0.2rem;
    }
  }

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 220;
  }
}
</style>
